export function isNotUndefined<T>(a: T | undefined): a is T {
  return a !== undefined;
}
